export function makeIsInn<T>(errorMsg: T) {
  return (value?: string) => {
    let isCorrect = false;

    if (value) {
      const [firstNumber, secondNumber] = value.split('');

      isCorrect = /^[\d+]{10}$/.test(value) || /^[\d+]{12}$/.test(value);
      if (Number(firstNumber) === 0 && firstNumber === secondNumber) {
        isCorrect = false;
      }
    }

    return isCorrect ? undefined : errorMsg;
  };
}
